import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../Card';

interface Props {
  tierLabel: string;
  reason: 'not_configured' | 'disabled';
}

const PortfolioTierEmptyState: React.FC<Props> = ({ tierLabel, reason }) => (
  <Card>
    <CardHeader>
      <CardTitle>{tierLabel}</CardTitle>
    </CardHeader>
    <CardContent className="space-y-3 text-sm text-gray-700">
      {reason === 'not_configured' ? (
        <p>
          This account does not have a portfolio slot for this tier yet. Open{' '}
          <strong>Settings</strong>, expand the account, use <strong>Portfolio setup</strong>,
          enable the tier, set allocations to 100%, and click <strong>Save portfolio setup</strong>.
        </p>
      ) : (
        <p>
          This tier is configured but <strong>disabled</strong>. Re-enable it in Settings →
          Portfolio setup and save.
        </p>
      )}
      <Link
        to="/app/settings"
        className="inline-block font-medium text-primary-600 hover:underline"
      >
        Go to Settings →
      </Link>
    </CardContent>
  </Card>
);

export default PortfolioTierEmptyState;
